import script from "./AuthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthPage.vue?vue&type=script&setup=true&lang=js"

import "./AuthPage.vue?vue&type=style&index=0&id=32726aff&lang=less&scoped=true"
import "./AuthPage.vue?vue&type=style&index=1&id=32726aff&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32726aff"]])

export default __exports__